var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFaturadosNafil = function SvgFaturadosNafil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 30.501,
    height: 30.501,
    viewBox: "0 0 8.07 8.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.917 3.833h25.917v30.75H4.917z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M124.001 94.727a3.917 3.917 0 0 1-3.917 3.917 3.917 3.917 0 0 1-3.916-3.917 3.917 3.917 0 0 1 3.916-3.917 3.917 3.917 0 0 1 3.917 3.917z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.206879,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.05 -90.692)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 12,
      lineHeight: 0.65,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "middle",
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline",
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.197 4.425-2.18.345q-.163-.416-.298-.574-.13-.164-.434-.328V5.56q1.781.475 2.38 1.002.79.71.79 1.8 0 .638-.287 1.17-.281.534-.727.892-.439.357-.937.521-.498.158-1.219.188v1.107h-.855v-1.107q-.862-.077-1.4-.276-.534-.205-.926-.562-.387-.358-.598-.768-.211-.416-.317-1.002l2.368-.275q.105.58.28.838.183.257.593.457V7.477q-1.184-.328-1.682-.568-.492-.24-.855-.768-.364-.533-.364-1.295 0-1.043.727-1.74.732-.703 2.174-.78v-.58h.855v.58q1.313.083 2.004.622.697.54.908 1.477zm-3.767-.586q-.375.123-.522.304-.146.182-.146.428 0 .258.146.451.153.188.522.317zm.855 5.765q.498-.111.727-.363.234-.258.234-.574 0-.276-.2-.504-.192-.235-.76-.434z",
    "aria-label": "$",
    style: {
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot"
    },
    transform: "matrix(.5286 0 0 .55334 -5.452 .099)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaturadosNafil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faturados_nafil.57f3866c.svg";
export { ForwardRef as ReactComponent };